// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"e6b44b54","602":"215e3914","764":"d1466598","845":"f8598421","894":"9073aba6","975":"49ddb529"}[chunkId] + ".css";
};